import { useMutation } from '@tanstack/react-query';
import { deleteEducationHistory } from 'src/shared/services/fn-api/Beneficiary';

export const useDeleteEducationHistory = () => {
  return useMutation<void, Error, number>({
    mutationFn: async (id: number) => {
      return deleteEducationHistory(id);
    },
  });
};
